import { styled } from 'styled-components';
import { Tooltip } from "@mantine/core";

import { textSmallSemiBold } from '../../Typography';

export const TooltipContainer = styled(Tooltip)`
  &.mantine-Tooltip-tooltip, &.mantine-TooltipFloating-tooltip {
    --tooltip-bg: var(--black-400);
    --tooltip-color: var(--text-standard-secondary);
    ${textSmallSemiBold}

    &.wordwrap {
        max-width: 250px;
    }
  }
`;
